// extracted by mini-css-extract-plugin
export var container = "_84-0";
export var error = "_84-9";
export var label = "_84-5";
export var light = "_84-6";
export var md = "_84-3";
export var sm = "_84-2";
export var thin = "_84-8";
export var thinBold = "_84-7";
export var vertical = "_84-4";
export var xs = "_84-1";